<template>
  <div>
    <a-card :bordered="false">
      <a-descriptions title="基本信息">
        <a-descriptions-item label="商户编号">{{
          merchantInfo.merchantNo
        }}</a-descriptions-item>
        <a-descriptions-item label="商户名称">{{
          merchantInfo.merchantName
        }}</a-descriptions-item>
        <a-descriptions-item label="商户类型">
          <a-tag
            class="render-tag"
            :color="merchantInfo.merchantType == '1' ? '#108ee9' : '#87d068'"
            >{{ merchantInfo.merchantType == "1" ? "公司" : "个人" }}</a-tag
          >
        </a-descriptions-item>

        <a-descriptions-item label="状态">
          <a-tag
            class="render-tag"
            :color="merchantInfo.sta == 'I' ? '#FF5722' : 'grey'"
            >{{ merchantInfo.sta == "I" ? "有效" : "停用" }}</a-tag
          >
        </a-descriptions-item>
        <a-descriptions-item label="认证状态">
          <a-tag
            class="render-tag"
            :color="merchantInfo.authSta == 'I' ? '#5FB878' : 'grey'"
          >
            {{
              merchantInfo.authSta == "I"
                ? "已认证"
                : merchantInfo.authSta == "R"
                ? "未认证"
                : "取消认证"
            }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="可用合同余量">{{
          merchantInfo.balanceUesable
        }}</a-descriptions-item>

        <a-descriptions-item label="地址" :span="3">{{
          merchantInfo.address
        }}</a-descriptions-item>
        <a-descriptions-item label="介绍" :span="3">{{
          merchantInfo.intro
        }}</a-descriptions-item>
        <a-descriptions-item :span="3" v-if="merchantInfo.logo">
          <div style="display: flex;align-items: center;">
            <div slot="label">
              Logo：
            </div>
            <div class="gallery">
              <img
                :src="merchantInfo.logo"
                @click="handlePreview(merchantInfo.logo)"
                class="gallery-item"
              />
            </div>
          </div>
        </a-descriptions-item>
      </a-descriptions>

      <a-divider />
      <a-descriptions
        title="认证信息(公司)"
        v-if="merchantInfo.merchantType == 1"
      >
        <a-descriptions-item label="公司名称">{{
          enterprise.enterpriseName
        }}</a-descriptions-item>
        <a-descriptions-item label="社会信用代码" :span="2">{{
          enterprise.licenseCode
        }}</a-descriptions-item>

        <a-descriptions-item label="经办人姓名">{{
          enterprise.legalPerson
        }}</a-descriptions-item>
        <a-descriptions-item label="经办人证件号">{{
          enterprise.legalPersonNo
        }}</a-descriptions-item>
        <a-descriptions-item label="联系方式">{{
          enterprise.contactMobile
        }}</a-descriptions-item>
        <a-descriptions-item label="联系邮箱">{{
          enterprise.contactEmail ? enterprise.contactEmail : "暂无"
        }}</a-descriptions-item>
        <a-descriptions-item label="认证状态">
          <a-tag
            class="render-tag"
            :color="enterprise.authSta == 'I' ? '#5FB878' : 'grey'"
            >{{ enterprise.authSta == "I" ? "已认证" : "失败" }}</a-tag
          >
        </a-descriptions-item>
        <a-descriptions-item label="认证方式">{{
          enterprise.authType == "api" ? "接口认证" : "人工认证"
        }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="3">{{
          enterprise.remark
        }}</a-descriptions-item>
        <a-descriptions-item
          label="认证失败原因"
          :span="3"
          v-if="enterprise.authSta == 'X'"
          >{{ enterprise.failRemark }}</a-descriptions-item
        >
        <a-descriptions-item :span="3" v-if="enterprise.licensePicture">
          <div style="display: flex;align-items: center;">
            <div slot="label">
              营业执照：
            </div>
            <div class="gallery">
              <img
                :src="enterprise.licensePicture"
                @click="handlePreview(enterprise.licensePicture)"
                class="gallery-item"
              />
            </div>
          </div>
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions title="认证信息(个人)" v-else>
        <a-descriptions-item label="真实姓名">{{
          personal.realName
        }}</a-descriptions-item>
        <a-descriptions-item label="身份证号">{{
          personal.idCardNo
        }}</a-descriptions-item>
        <a-descriptions-item label="银行卡号">{{
          personal.bankNo
        }}</a-descriptions-item>
        <a-descriptions-item label="手机号">{{
          personal.mobile
        }}</a-descriptions-item>
        <a-descriptions-item label="认证状态">
          <a-tag
            class="render-tag"
            :color="personal.authSta == 'I' ? '#5FB878' : 'grey'"
            >{{ personal.authSta == "I" ? "已认证" : "失败" }}</a-tag
          >
        </a-descriptions-item>
        <a-descriptions-item label="认证次数">{{
          personal.authLimit
        }}</a-descriptions-item>
        <a-descriptions-item label="认证方式">{{
          personal.authType == "api" ? "接口认证" : "人工认证"
        }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">{{
          personal.remark
        }}</a-descriptions-item>
        <a-descriptions-item
          label="认证失败原因"
          :span="3"
          v-if="personal.authSta == 'X'"
          >{{ personal.failRemark }}</a-descriptions-item
        >
        <a-descriptions-item
          :span="3"
          v-if="personal.cardFrontPic || personal.cardReversePic"
        >
          <div style="display: flex;align-items: center;">
            <div slot="label">
              身份证：
            </div>
            <div class="gallery">
              <img
                :src="personal.cardFrontPic"
                @click="handlePreview(personal.cardFrontPic)"
                class="gallery-item"
              />
              <img
                :src="personal.cardReversePic"
                @click="handlePreview(personal.cardReversePic)"
                class="gallery-item"
              />
            </div>
          </div>
        </a-descriptions-item>
      </a-descriptions>
      <!-- <a-divider />
      <a-descriptions title="收款账户信息"></a-descriptions>
      <a-list :data-source="accountList" item-layout="horizontal">
        <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
          <a-list-item-meta>
            <a slot="title">{{ item.accountType }}</a>
            <div slot="description">
              <span style="color: #000000;">账户名:</span>
              <span style="padding: 0 5px;">{{ item.accountName }}</span>
              <span style="color: #000000;margin-left: 10px;">账号:</span>
              <span style="padding: 0 5px;">{{ item.accountNo }}</span>
            </div>
          </a-list-item-meta>
          <div>
            <a-tag
              class="render-tag"
              color="#108ee9"
              v-if="item.isDefault == 'T'"
              >默认账户</a-tag
            >
          </div>
        </a-list-item>
      </a-list>
      <a-divider /> -->
    </a-card>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel"
      ><img alt="example" style="width: 100%" :src="previewImage"
    /></a-modal>
  </div>
</template>

<script>
export default {
  name: "MerchantInfo",
  data() {
    return {
      userInfo: null,
      isAuth: false, //是否认证
      queryParam: null, //主页面(list)查询条件
      merchantNo: "", // 商户编号
      enterprise: {}, //企业认证信息
      personal: {}, //个人认证信息
      merchantInfo: {}, //商户基本信息
      logoList: [],
      accountList: [], //商户账户信息
      previewVisible: false, //预览图片modal
      previewImage: "", //图片地址
      auditModal: {
        visible: false,
        title: "",
        content: "",
        type: "",
        failRemark: "", //不通过原因
        loading: false
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.merchantNo = this.userInfo.merchantNo;
    this.getMerchantInfo();
  },
  methods: {
    async getMerchantInfo() {
      this.$http.roomBksApi
        .findMerchantBaseByMerchantNo({ merchantNo: this.merchantNo })
        .then(res => {
          if (res && res.result == 0) {
            this.enterprise = res.resultObject.enterprise;
            this.personal = res.resultObject.personal;
            this.merchantInfo = res.resultObject.merchantInfo;
            this.accountList = res.resultObject.merchantAccountList;

            if (this.merchantInfo.logo) {
              let item = {};
              item.id = 1;
              item.url = this.merchantInfo.logo;
              item.status = "done";
              this.logoList.push(item);
            }
          }
        });
    },
    async handlePreview(file) {
      this.previewImage = file;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  .gallery-item {
    height: 100px;
    width: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.operation {
  text-align: center;
  margin: 20px auto 5px;
  button {
    margin: 0 10px;
  }
}
</style>
